var _path, _path2, _rect, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendarWeatherWidget = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 26,
  viewBox: "0 0 25 26",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.8816 25.5636H2.05944C1.47455 25.5636 1 25.0894 1 24.5042V11.3552H1.26561C1.60389 11.3552 1.87794 11.6296 1.87794 11.9676V24.5042C1.87794 24.6046 1.95935 24.6857 2.05944 24.6857H22.8816C22.982 24.6857 23.0631 24.6046 23.0631 24.5042V7.31586H23.9411V24.5042C23.9411 25.0894 23.4668 25.5636 22.8816 25.5636Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.87794 7.74787H1V3.40368C1 2.81848 1.47455 2.34424 2.05974 2.34424H22.8816C23.4668 2.34424 23.9411 2.81848 23.9411 3.40368V4.63135H23.8151C23.3999 4.63135 23.0631 4.29459 23.0631 3.87943V3.40368C23.0631 3.30388 22.9814 3.22188 22.8813 3.22188H2.05944C1.95935 3.22188 1.87794 3.30328 1.87794 3.40368V7.74787Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.00488,
  y: 7.30884,
  width: 22.4973,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8558 4.29878H19.6348V1.91549C19.6348 1.55521 19.9269 1.26306 20.2872 1.26306H20.5127V3.64183C20.5127 4.00452 20.2185 4.29878 19.8558 4.29878Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.29739 4.29878H4.12012V1.917C4.12012 1.55581 4.41286 1.26306 4.77405 1.26306H4.99806V3.59811C4.99806 3.98523 4.68421 4.29878 4.29739 4.29878Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 8.28223,
  y: 12.2735,
  width: 1.86201,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3853,
  y: 12.2735,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 14.4883,
  y: 12.2735,
  width: 1.86201,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5918,
  y: 12.2735,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 5.17969,
  y: 15.3768,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 8.28223,
  y: 15.3768,
  width: 1.86201,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3853,
  y: 15.3768,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 14.4883,
  y: 15.3768,
  width: 1.86201,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5918,
  y: 15.3768,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5918,
  y: 18.4797,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 5.17969,
  y: 12.2735,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 5.17969,
  y: 18.4797,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 8.28223,
  y: 18.4797,
  width: 1.86201,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3853,
  y: 18.4797,
  width: 1.86171,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 14.4883,
  y: 18.4797,
  width: 1.86201,
  height: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
})));
export default "data:image/svg+xml;base64,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";
export { SvgCalendarWeatherWidget as ReactComponent };